const SOLAR_RATE_TITLE = "Solar Rate";
const EST_MONTHLY_SOLAR_TITLE = "Est. Monthly Solar";
const MONTHLY_BATTERY_TITLE = "Monthly Battery";

const PrMonthlyColumnsToHide = [
  SOLAR_RATE_TITLE,
  EST_MONTHLY_SOLAR_TITLE,
  MONTHLY_BATTERY_TITLE,
];

export {
  SOLAR_RATE_TITLE,
  EST_MONTHLY_SOLAR_TITLE,
  MONTHLY_BATTERY_TITLE,
  PrMonthlyColumnsToHide,
};
